import React from "react";
import { Helmet } from "react-helmet-async";
import "./privacy-policy.css";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-wrapper">

      {/* SEO */}
      <Helmet>
        <title>Privacy Policy | Customersupports24x7 Bangalore</title>
        <meta
          name="description"
          content="Read the privacy policy of Customersupports24x7 regarding customer data, service information, and website use."
        />
        <meta
          name="keywords"
          content="website privacy policy"
        />
        <meta property="og:title" content="Privacy Policy | Customersupports24x7 Bangalore" />
        <meta
          property="og:description"
          content="Read the privacy policy of Customersupports24x7 regarding customer data, service information, and website use."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/privacy-policy" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Privacy Policy | Customersupports24x7 Bangalore" />
        <meta
          name="twitter:description"
          content="Read the privacy policy of Customersupports24x7 regarding customer data, service information, and website use."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/privacy-policy" />
      </Helmet>

      {/* Banner */}
      <InnerBanner title="Privacy Policy" bgImage={serviceBg} />

      {/* 🔥 MAIN CONTENT */}
      <div className="privacy-container">

        <h1 className="privacy-title" style={{ color: '#ff0000' }}>🔒 Privacy Policy</h1>

        <p><strong>Effective Date:</strong> 26 March 2026</p>

        <p style={{ textAlign: 'justify' }}>
          At Customer support 24*7 appliance repair, we respect your privacy and are committed to protecting your personal information.
          This Privacy Policy explains how we collect, use, and safeguard your data when you use our appliance repair services.
        </p>

        <h2>1. Information We Collect</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Name, phone number, and address for booking services</li>
          <li>Appliance details (type, brand, issue description)</li>
          <li>Location details for doorstep service</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>To schedule and deliver repair services</li>
          <li>To contact you for service updates and support</li>
          <li>To improve our service quality and customer experience</li>
        </ul>

        <h2>3. Data Protection</h2>
        <p    style={{ textAlign: 'justify' }}>
          We take appropriate security measures to protect your personal data.
          Your information is kept secure and is not sold or shared with third parties,
          except when required by law.
        </p>

        <h2>4. Device & Data Responsibility</h2>
        <ul style={{ textAlign: 'justify' }}>
          <li>Customers must back up their data before service</li>
          <li>We are not responsible for any data loss during repair</li>
        </ul>

        <h2>5. Cookies</h2>
        <p style={{ textAlign: 'justify' }}>
          Our website may use cookies to enhance user experience and improve website performance.
        </p>

        <h2>6. Third-Party Links</h2>
        <p style={{ textAlign: 'justify' }}>
          We are not responsible for privacy practices of external websites linked from our platform.
        </p>

        <h2>7. Policy Updates</h2>
        <p style={{ textAlign: 'justify' }}>
          We may update this Privacy Policy from time to time. Changes will be reflected on this page.
        </p>

        <h2>8. Contact Us</h2>
      <div className="cta-box">
  📞 
  <a href="tel:8050731754" style={{ color: "inherit", textDecoration: "none" }}>
    8050731754
  </a>
  <br />

  📧 
  <a href="mailto:info@customersupport24x7.in" style={{ color: "inherit", textDecoration: "none" }}>
    info@customersupport24x7.in
  </a>
</div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
